import { AccessRequestFormCore } from '@/components/access-request/access-request-form-core'
import { AuthBackToSignInLink } from '@/components/auth/auth-back-to-sign-in-link'
import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'

type AccessRequestFormAuthProps = {
  className?: string
}

/** Auth-page access request form for waitlist and invite-only tenants. */
export function AccessRequestFormAuth({ className }: AccessRequestFormAuthProps) {
  return (
    <div className={cn('flex flex-col gap-6', className)}>
      <AccessRequestFormCore
        variant="auth"
        formClassName="flex flex-col gap-6"
        errorClassName="p-4 text-sm text-destructive border border-destructive/20 rounded-md bg-destructive/10"
        successPanelClassName="text-center"
        renderSubmit={({ submitting, submitLabel }) => (
          <Button type="submit" className="w-full" disabled={submitting}>
            {submitting ? 'Submitting…' : submitLabel}
          </Button>
        )}
      />
      <AuthBackToSignInLink />
    </div>
  )
}
